
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software/mobile-app",
      function () {
        return require("private-next-pages/software/mobile-app/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software/mobile-app"])
      });
    }
  